import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { ServiceBase } from '../service-base';
import { LegalConsent } from 'src/app/@shared/models/legal/legal-consent.model';
import { ODataResponse } from 'src/app/@shared/utilities/odata/response';
import { Logger } from '../logger/logger.service';

const LOGGER = new Logger('LegalConsentService');

const CLASS_NAME = 'LegalConsent';
const ENDPOINT = `/legal-consents/`;

@Injectable({
    providedIn: 'root'
})
export class LegalConsentService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }

    public accept$(documentId: number, clientId?: number): Observable<LegalConsent | null> {
        const body: any = { document_id: documentId };
        if (clientId != null) {
            body['client_id'] = clientId;
        }
        this._creating$.next(true);
        return this.httpClient.post(this.routes.create, body).pipe(
            finalize(() => this._creating$.next(false)),
            map((data: any) => {
                const response = new ODataResponse(data);
                this.messageService.sendODataMessages(response.messages);
                return new LegalConsent(response.value);
            }),
            catchError((error: any) => {
                this.handleError(error);
                return of(null);
            })
        );
    }
}
